<template>
  <div class="question-paper-manager">
    <Form :model="searchCondition" :label-width="70" inline>
      <FormItem label="试卷类型">
        <Select v-model="searchCondition.type" style="width:200px;" clearable>
          <Option
            v-for="(item, index) in paperTypes"
            :key="index"
            :value="item.key"
          >{{item.value}}</Option>
        </Select>
      </FormItem>
      <FormItem label="试卷分类">
        <Cascader
          ref="paperClassify"
          :data="paperClassify"
          trigger="hover"
          style="width:200px;"
          change-on-select
          @on-change="searchCondition.classify_id = $event.pop()"
        ></Cascader>
      </FormItem>
    </Form>
    <Form :model="searchCondition" :label-width="70" inline>
      <FormItem label="试卷状态">
        <Select v-model="searchCondition.status" style="width:200px;" clearable>
          <Option
            v-for="(item, index) in paperStatus"
            :key="index"
            :value="item.key"
          >{{item.value}}</Option>
        </Select>
      </FormItem>
      <FormItem label="试卷名称">
        <Input
          v-model="searchCondition.name"
          placeholder="请输入试卷关键字"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="onSearch"
        ></Input>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="onSearch">搜索</Button>
          <Button icon="md-undo" @click="onReset">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div>
      <Button type="primary" @click="showModal = true" style="margin-right:50px;">新增试卷</Button>
      <Checkbox
        v-model="searchCondition.creator_flag"
        :true-value="1"
        :false-value="0"
        @on-change="onSearch"
      >只看我创建的</Checkbox>
    </div>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/exam/index"
        :search="searchCondition"
        :rowsFormatter="onrowsFormatter"
        @onSelectionChange="onSelectionChange"
        selectType="multi"
        keyField="id"
        method="post"
      >
        <template slot-scope="{row}" slot="action">
          <div>
            <Button type="text" size="small" @click="onDetail(row)">详情</Button>
            <span>-</span>
            <Button
              type="text"
              size="small"
              @click="onForbidden(row)"
            >{{row.status == 1 ? '禁用' : '启用'}}</Button>
            <span>-</span>
            <Button type="text" size="small" @click="onEdit(row)">编辑</Button>
            <span>-</span>
            <Button type="text" size="small" @click="onDelete(row)">删除</Button>
          </div>
        </template>
        <template slot="footer-left">
          <Button class="btn-margin-right" size="small" @click="onForbidden('select', 1)">启用</Button>
          <Button class="btn-margin-right" size="small" @click="onForbidden('select', 0)">禁用</Button>
          <Button class="btn-margin-right" size="small" @click="onDelete('select')">删除</Button>
        </template>
      </Grid>
    </div>
    <Modal v-model="showModal" class-name="vertical-center-modal">
      <div slot="header" style="text-align:center;font-size:16px;font-weight:500;">选择试卷类型</div>
      <div class="modal-content">
        <div class="modal-item" @click="onAddPaper(0)">
          <p class="modal-item-title vmiddle">
            <Icon type="ios-create" size="18" color="#2d8cf0" />
            <span>人工卷</span>
          </p>
          <p>需手动搜索定位到具体题目，组成试卷</p>
        </div>
        <div class="modal-item" @click="onAddPaper(1)">
          <p class="modal-item-title vmiddle">
            <Icon type="md-calculator" size="18" color="#2d8cf0" />
            <span>随机卷</span>
          </p>
          <p>预先设置好从一个或多个题库中随机选题，抽取题目后组成试卷</p>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import { QuestionPaperType, QuestionPaperStatus } from "@/utils/enums";
export default {
  name: "question-paper-manager",
  data() {
    return {
      paperTypes: QuestionPaperType.getOptions(),
      paperStatus: QuestionPaperStatus.getOptions(),
      paperClassify: [],
      searchCondition: {
        type: "",
        classify_id: "",
        status: "",
        name: "",
        creator_flag: 0,
        init() {
          this.type = "";
          this.classify_id = "";
          this.status = "";
          this.name = "";
        }
      },
      tableColumns: [
        { title: "试卷名称", key: "name", minWidth: 200 },
        {
          title: "所属分类",
          key: "classify_name",
          align: "center",
          minWidth: 150
        },
        { title: "试卷类型", key: "typeName", align: "center", width: 90 },
        { title: "试题数量", key: "question_num", align: "center", width: 90 },
        { title: "状态", key: "statusName", align: "center", width: 80 },
        { title: "是否使用", key: "isUsedName", align: "center", width: 90 },
        { title: "创建人", key: "nickname", align: "center", width: 120 },
        { title: "更新时间", key: "updated_at", align: "center", width: 150 },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: 150,
          fixed: "right"
        }
      ],
      selection: [], //选中的试卷
      showModal: false
    };
  },
  created() {
    this.requestPaperClassify();
  },
  methods: {
    // on event
    onAddPaper(type) {
      this.$router.push({
        name: "QuestionPaperAdd",
        query: {
          type
        }
      });
    },
    onSearch() {
      this.$refs.grid.searchRefresh();
    },
    onReset() {
      this.searchCondition.init();
      this.$refs.paperClassify.clearSelect();
      this.onSearch();
    },
    onrowsFormatter(rows) {
      rows.forEach(i => {
        i.typeName = QuestionPaperType.getValue(i.type);
        i.statusName = QuestionPaperStatus.getValue(i.status);
        i.isUsedName = i.is_used ? "已使用" : "未使用";
      });
    },
    onSelectionChange(items) {
      this.selection = items;
    },
    onDetail(row) {
      this.$router.push({
        name: "QuestionPaperDetail",
        query: {
          id: row.id
        }
      });
    },
    onForbidden(row, status) {
      if (row === "select") {
        if (this.selection.length == 0) {
          this.$Message.info("请先选择试卷");
          return;
        }
        const ids = [];
        this.selection.forEach(i => {
          ids.push(i.id);
        });
        this.$http
          .get(`/api/exam/disableEnable/${ids.join()}/${status}`)
          .then(() => {
            this.$refs.grid.refresh();
            this.selection = [];
            this.$Message.success("批量操作成功");
          });
      } else {
        this.$http
          .get(`/api/exam/disableEnable/${row.id}/${row.status == 0 ? 1 : 0}`)
          .then(() => {
            this.$Message.success(row.status == 0 ? "启用成功" : "禁用成功");
            this.$refs.grid.refresh();
          });
      }
    },
    onEdit(row) {
      if (row.is_used && row.status == 1) {
        this.$Modal.error({
          title: "提示",
          content: "当前试卷已“被使用”且“被启用”，无法编辑"
        });
        return;
      }
      this.$router.push({
        name: "QuestionPaperEdit",
        query: {
          id: row.id
        }
      });
    },
    onDelete(row) {
      if (row === "select") {
        // check
        if (this.selection.length == 0) {
          this.$Message.info("请先选择试卷");
          return;
        }
        for (const i of this.selection) {
          if (i.is_used) {
            this.$Modal.error({
              title: "提示",
              content: "含有已被使用的试卷，无法删除"
            });
            return;
          }
        }
        // process
        this.$Modal.confirm({
          title: "提示",
          content: "确定要删除该试卷吗？",
          onOk: () => {
            const ids = [];
            this.selection.forEach(i => {
              ids.push(i.id);
            });
            this.$http.delete(`/api/exam/delete/${ids.join()}`).then(() => {
              this.$refs.grid.refresh();
              this.selection = [];
              this.$Message.success("批量操作成功");
            });
          }
        });
      } else {
        if (row.is_used) {
          this.$Modal.error({
            title: "提示",
            content: "当前试卷已被使用，无法删除"
          });
          return;
        }
        this.$Modal.confirm({
          title: "提示",
          content: "确定要删除该试卷吗？",
          onOk: () => {
            this.$http.delete(`/api/exam/delete/${row.id}`).then(() => {
              this.$refs.grid.refresh();
              this.$Message.success("删除成功");
            });
          }
        });
      }
    },
    // request
    requestPaperClassify() {
      this.$http.get("/api/course/classify").then(data => {
        this.paperClassify = data;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-content {
  display: flex;
  justify-content: space-around;
  margin: 20px 0;
  .modal-item {
    border: 1px solid #eee;
    width: 180px;
    padding: 20px;
    cursor: pointer;
    .modal-item-title {
      text-align: center;
      margin-bottom: 10px;
    }
  }
}
</style>
